(() => {
  if (customElements.get('liene-deal-nav')) return;
  customElements.define('liene-deal-nav', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.links = [...this.querySelectorAll('[data-target]')];
      this.track = this.querySelector('nav');
      this.wrapper = this.closest('.shopify-section');
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-target]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        const target = document.getElementById(link.dataset.target);
        event.preventDefault();
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - this.offset();
        window.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        history.replaceState(history.state, '', `#${encodeURIComponent(link.dataset.target)}`);
        this.activate(link);
        // Move keyboard focus without starting a second, un-offset scroll.
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
        }
        target.focus({ preventScroll: true });
      }, options);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      this.headers = [...document.querySelectorAll('.section-liene-header .lh-header')];
      this.headerObserver = new ResizeObserver(this.schedule);
      this.headers.forEach(header => {
        this.headerObserver.observe(header);
        header.addEventListener('transitionend', this.schedule, options);
      });
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      document.addEventListener('shopify:section:load', this.schedule, options);
      document.addEventListener('shopify:section:unload', this.schedule, options);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
      this.update();
    }

    syncHeaderOffset() {
      if (!this.headers.length) return;
      let bottom = 0;
      this.headers.forEach(header => {
        const style = getComputedStyle(header);
        if (!['fixed', 'sticky'].includes(style.position) || style.visibility === 'hidden') return;
        const rect = header.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) bottom = Math.max(bottom, rect.bottom);
      });
      this.wrapper.style.setProperty('--deal-nav-header-offset', `${Math.max(0, bottom)}px`);
    }

    offset() {
      this.syncHeaderOffset();
      const header = parseFloat(getComputedStyle(this.wrapper).top) || 0;
      return header + (this.dataset.sticky === 'true' ? this.wrapper.getBoundingClientRect().height : 0) + 16;
    }

    activate(link) {
      if (link === this.active) return;
      this.active = link;
      this.links.forEach(item => item === link ? item.setAttribute('aria-current', 'location') : item.removeAttribute('aria-current'));
      if (!link) return;
      const tab = link.getBoundingClientRect(), track = this.track.getBoundingClientRect();
      if (matchMedia('(max-width: 767px)').matches) {
        // Scroll only the tab strip; scrollIntoView can also move the page.
        this.track.scrollBy({
          left: tab.left + tab.width / 2 - track.left - track.width / 2,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      } else if (tab.left < track.left || tab.right > track.right) {
        const gutter = parseFloat(getComputedStyle(this.track).paddingLeft) || 4;
        this.track.scrollBy({ left: tab.left - track.left - gutter, behavior: 'instant' });
      }
    }

    update() {
      const entries = this.links.map(link => ({ link, target: document.getElementById(link.dataset.target) })).filter(entry => entry.target && entry.target.getClientRects().length);
      entries.sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);
      const line = this.offset() + 2;
      let current = entries[0]?.link;
      for (const entry of entries) if (entry.target.getBoundingClientRect().top <= line) current = entry.link;
      if (window.scrollY > 0 && Math.ceil(window.scrollY + window.innerHeight) >= document.documentElement.scrollHeight - 2) current = entries.at(-1)?.link;
      this.activate(current);

    }

    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
      this.headerObserver.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.active = null;
    }
  });
})();
